// Check if the app is running in demo mode via environment variable
export const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

export default isDemoMode;
